import Phaser from 'phaser';

import Carrot from '../objects/Carrot';
import Player from '../objects/Player';

import bgLayer1Image from '../../../assets/images/BunnyInfinity/JumperPack/Background/bg_layer1.png';
import groundGlassImage from '../../../assets/images/BunnyInfinity/JumperPack/Environment/ground_grass.png';
import bunny1StandImage from '../../../assets/images/BunnyInfinity/JumperPack/Players/bunny1_stand.png';
import bunny1JumpImage from '../../../assets/images/BunnyInfinity/JumperPack/Players/bunny1_jump.png';
import CarrotImage from '../../../assets/images/BunnyInfinity/JumperPack/Items/carrot.png';

class Main extends Phaser.Scene {
  /** @type {Phaser.Types.Input.Keyboard.CursorKeys} */
  cursors;

  /** @type {Phaser.Physics.Arcade.StaticGroup} */
  platforms;

  /** @type {Phaser.Physics.Arcade.Sprite} */
  player;

  /** @type {Phaser.Physics.Arcade.Group} */
  carrots;

  /** @type {Phaser.GameObjects.Text} */
  carrotsCollectedText;

  carrotsCollected = 0;

  constructor() {
    super('main');
  }

  init() {
    this.carrotsCollected = 0;
  }

  preload() {
    this.load.image('background', bgLayer1Image);
    this.load.image('platform', groundGlassImage);
    this.load.image('bunny-stand', bunny1StandImage);
    this.load.image('bunny-jump', bunny1JumpImage);
    this.load.image('carrot', CarrotImage);
  }

  create() {
    this.cursors = this.input.keyboard.createCursorKeys();

    this.add.image(240, 320, 'background').setScrollFactor(1, 0);

    this.platforms = this.physics.add.staticGroup();
    for (let i = 0; i < 5; i++) {
      const x = Phaser.Math.Between(80, 400);
      const y = 150 * i;
      const platform = this.platforms.create(x, y, 'platform');
      platform.scale = 0.5;
      platform.body.updateFromGameObject();
    }

    this.player = new Player(this, 240, 320, 'bunny-stand');
    this.carrots = this.physics.add.group({ classType: Carrot });

    this.physics.add.collider(this.platforms, this.player);
    this.physics.add.collider(this.platforms, this.carrots);
    this.physics.add.overlap(
      this.player,
      this.carrots,
      this.handleCollectCarrot,
      undefined,
      this,
    );

    this.cameras.main.startFollow(this.player);
    this.cameras.main.setDeadzone(this.scale.width * 1.5);

    this.carrotsCollectedText = this.add
      .text(240, 10, 'Carrots: 0', { color: '#000', fontSize: 24 })
      .setScrollFactor(0)
      .setOrigin(0.5, 0);
  }

  update() {
    // reuse platforms
    this.platforms.children.iterate((child) => {
      const { scrollY } = this.cameras.main;
      if (child.y >= scrollY + 700) {
        child.y = scrollY - Phaser.Math.Between(50, 100);
        child.body.updateFromGameObject();
        this.addCarrotAbove(child);
      }
    });

    // set velocity and texture for player
    const touchingDown = this.player.body.touching.down;
    if (touchingDown) {
      this.player.setVelocityY(-300);
      this.player.setTexture('bunny-jump');
    } else {
      const { left, right } = this.cursors;
      if (left.isDown) {
        this.player.setVelocityX(-150);
      } else if (right.isDown) {
        this.player.setVelocityX(150);
      } else {
        this.player.setVelocityX(0);
      }
    }
    const vy = this.player.body.velocity.y;
    if (vy >= 0 && this.player.texture.key !== 'bunny-stand') {
      this.player.setTexture('bunny-stand');
    }

    // set horizontal wrap for player
    const halfWidth = this.player.displayWidth * 0.5;
    const gameWidth = this.scale.width;
    if (this.player.x < -halfWidth) {
      this.player.x = gameWidth + halfWidth;
    } else if (this.player.x > gameWidth + halfWidth) {
      this.player.x = -halfWidth;
    }

    // check gameover
    const bottomPlatform = this.findBottomMostPlatform();
    if (this.player.y > bottomPlatform.y + 200) {
      this.scene.start('game-over');
    }
  }

  addCarrotAbove(sprite) {
    const y = sprite.y - sprite.displayHeight;
    const carrot = this.carrots.get(sprite.x, y, 'carrot');
    carrot.setActive(true);
    carrot.setVisible(true);
    carrot.body.setSize(carrot.width, carrot.height);
    this.physics.world.enable(carrot);
    return carrot;
  }

  handleCollectCarrot(player, carrot) {
    this.carrots.killAndHide(carrot);
    this.physics.world.disableBody(carrot.body);
    this.carrotsCollected++;
    this.carrotsCollectedText.text = `Carrots: ${this.carrotsCollected}`;
  }

  findBottomMostPlatform() {
    const platforms = this.platforms.getChildren();
    let bottomPlatform = platforms[0];
    for (let i = 1; i < platforms.length; i++) {
      const platform = platforms[i];
      if (platform.y >= bottomPlatform.y) {
        bottomPlatform = platform;
      }
    }
    return bottomPlatform;
  }
}

export default Main;
